import logServices from '../../services/log';
import Log from '../../model/log';

export const state = {
    logs: [],
    log: {},
}

export const mutations = {
    setLogs(state, logs) {
        state.logs = logs
    },
    setLog(state, log) {
        state.log = log
    }
}

export const getters = {
    getLogs(state) {
        return state.logs.map((log)=> new Log(log));
    },
    getLog(state) {
        return new Log(state.log);
    }
}

export const actions = {
    get({commit}, id){
        return logServices.get(id)
        .then((response)=>{
            commit('setLog', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return logServices.getAll(data)
        .then((response)=>{
            commit('setLogs', response.data.data)
            return response
        })
    },
}